import { useXGScale } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { useTheme } from 'styled-components';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { BLOCKED_OUTCOME, OWN_GOAL_TYPE } from '@/consts/visualisations';
import { ShotMapEventMarker } from '@/types/visualisation';
import { isNullish } from '@/utils/predicates';
import { useObvScale } from '../useObvScale';

export const useShotMarkerFill = () => {
  const theme = useTheme();
  const { dataObjects } = theme.colours.visualisations;
  const getXgColor = useXGScale();
  const getObvColor = useObvScale();
  const colouringMode = useAtomValue(pitchMarkerColouringModeAtom);

  const getMarkerFill = (event: ShotMapEventMarker) => {
    if (event.type === OWN_GOAL_TYPE) return dataObjects.inverse;
    if (event.outcome === BLOCKED_OUTCOME) return dataObjects.neutral.main;
    if (colouringMode === 'obv') return isNullish(event.obv) ? dataObjects.neutral.main : getObvColor(event.obv);
    return getXgColor(event.xg ?? 0);
  };

  return getMarkerFill;
};
